// Module
var code = " <scorm-host></scorm-host> ";
// Exports
module.exports = code;